import Keycloak from "keycloak-js";

// Get environment-specific URLs
const getKeycloakConfig = () => {
  const hostname = window.location.hostname;

  console.log('Keycloak config - hostname:', hostname);

  // Production environment
  if (hostname === 'app.finderz.ai' || hostname === 'finderz.ai' || hostname === 'www.finderz.ai') {
    console.log('Using production Keycloak config for:', hostname);
    return {
      url: "https://keycloak.finderz.ai",
      realm: "finderz-prod",
      clientId: "frontend",
    };
  } else if (hostname === 'preprod.finderz.ai' || hostname.includes('preprod.finderz.ai')) {
    console.log('Using preproduction Keycloak config for:', hostname);
    return {
      url: "https://keycloak.preprod.finderz.ai",
      realm: "finderz-prod",
      clientId: "frontend",
    };
  } else if (hostname.includes('stage')) {
    console.log('Using stage Keycloak config');
    return {
      url: "https://keycloak.stage.finderz.dev",
      realm: "finderz-stage",
      clientId: "frontend",
    };
  } else if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    // Development environment
    console.log('Using development Keycloak config (stage)');
    return {
      url: "https://keycloak.finderz.dev", // Use stage for development
      realm: "finderz-dev",
      clientId: "frontend",
    };
  } else {
    // Fallback to stage for any other domains (like dev environments)
    console.log('Using stage Keycloak config (fallback) for:', hostname);
    return {
      url: "https://keycloak.finderz.dev",
      realm: "finderz-dev",
      clientId: "frontend",
    };
  }
};

// Create a singleton Keycloak instance
let keycloakInstance: Keycloak | null = null;

const getKeycloakInstance = () => {
  if (!keycloakInstance) {
    console.log('🔐 Creating new Keycloak instance...');
    keycloakInstance = new Keycloak(getKeycloakConfig());
  } else {
    console.log('🔐 Using existing Keycloak instance...');
  }
  return keycloakInstance;
};

const keycloak = getKeycloakInstance();

export default keycloak;
